module.exports = {"title":"Log in","loginButton":"Log in","password":"Password","notRegistered":"Not yet on OMyFu?","registerForFree":"Register free of charge","lostPassword":"Forgotten your password?","meta":"Log in"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/login.json
// module id = 59n7
// module chunks = 1